import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronLeftSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.793 5.293a1 1 0 1 1 1.414 1.414L9.914 12l5.293 5.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-6-6a1 1 0 0 1 0-1.414z"
    />
  </svg>
);
export default SvgChevronLeftSmall;
